import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function SoundPage() {

  return (
    <ProjectLayout
      title="Tech Gym"
      role="Unity Developer (C#) - UR3 Robot"
      team="2"
      duration="6 Months"
      engine="Unity (C#)"
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/tech2.mp4`}
      playLink={`https://www.uts.edu.au/news/2018/07/tech-gym-using-robotics-rehabilitation`}
      playText={"Tech Gym Article"}
      galleryImages = {[
    `${process.env.PUBLIC_URL}/img/tech/1.png`,
    `${process.env.PUBLIC_URL}/img/tech/2.png`,
  ]}
    >
      <section>
        <h2>About</h2>
        <p>    Tech Gym was a startup at UTS which aimed to help stroke patients in their upper limb recovery through an interactive Unity application linked to a UR3 robotics system.
</p>
      </section>

      <section>
        <h2>What I Learned</h2>
        <p>
            This was my first major Unity project, and I learned a lot about working with other engineers, integrating with physical systems, and designing for a disabled audience.
            The Unity game involved the user handling various objects in a kitchen using the UR3 robot, in order to help them re-establish some of their motor functions related to daily activities.
        </p>
      </section>

    
    </ProjectLayout>
  );
}
